// extracted by mini-css-extract-plugin
export default {"form":"classes_form__LvlB8","form-container":"classes_form-container__bQJXz","button-container":"classes_button-container__DBZkN"};